import type { ApiTablePageComponent } from 'components/ApiTablePage/ApiTablePageComponent';
import { LicenseConsumptionOverviewApiTablePage } from 'components/ApiTablePage/customPages/LicenseConsumptionOverviewApiTablePage';
import { PathVerificationsApiTablePage } from 'components/ApiTablePage/customPages/PathVerificationsApiTablePage';

export const apiTablePageComponentMap: {
  [key: string]: ApiTablePageComponent;
} = {
  '/settings/administration/license-consumption/overview':
    LicenseConsumptionOverviewApiTablePage,
  '/technology/routing/path-verifications': PathVerificationsApiTablePage,
};
